export default __webpack_public_path__ + "static/media/clout.334d304f.png";